import React from "react"
import { useFormContext } from "@carrotfertility/carotene-core-x"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { usePreVisitTracking } from "./hooks/usePreVisitTracking"

export function PreVisitFormTracking(): null {
  const { track } = usePreVisitTracking()
  const {
    formState: { isDirty }
  } = useFormContext()
  const viewed = React.useRef(false)
  const started = React.useRef(false)

  React.useEffect(() => {
    if (!viewed.current) {
      viewed.current = true
      track(MemberActions.PRE_VISIT_FORM_VIEWED)
    }
    if (isDirty && !started.current) {
      started.current = true
      track(MemberActions.PRE_VISIT_FORM_STARTED)
    }
  }, [isDirty, track])

  return null
}
